import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Divider,
   FormControlLabel,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
   InputAdornment,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { Controller, useForm } from 'react-hook-form';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import 'react-nice-dates/build/style.css';
import {
   AlertLabel,
   Input,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import SearchRule from '../../Search/SearchRule';
import SearchEmployee from '../../Search/SearchEmployee';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { MySelect } from '../../Select/Select';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
const limitRelatedPerson = 2;
const optionsRules = [
   { value: 1, label: 'หลักเกณฑ์หลัก' },
   { value: 2, label: 'หลักเกณฑ์รอง' },
];
const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '50%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
   dividerFullWidth: {
      margin: `5px 0 0 ${theme.spacing(2)}px`,
   },
}));
const Create = (props) => {
   const classes = useStyles();
   const [relatedPersons, setRelatedPersons] = useState([]);
   const [tableData, setTableData] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         rulePointAmount: new Intl.NumberFormat().format(0),
         gPoint: new Intl.NumberFormat().format(0),
         sPoint: new Intl.NumberFormat().format(0),
         bPoint: new Intl.NumberFormat().format(0),
      },
   });
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingOptions, setIsLoadingOptions] = useState(false);
   const [respOptions, setRespOptions] = useState(null);
   const [optionsHr, setOptionHr] = useState([
      {
         value: undefined,
         label: undefined,
      },
   ]);
   const [stateRuleMain, setStateRuleMain] = useState({
      disable: true,
      isRequire: false,
   });
   const [stateRuleSub, setStateRuleSub] = useState({
      disable: true,
      isRequire: false,
   });
   const [ruleCode, setRuleCode] = useState('');
   const [years, setYears] = useState([]);
   const closeRef = useRef();
   useEffect(() => {
      getHrWallet();
      setYearsDropdown();
   }, []);
   const setYearsDropdown = () => {
      const currentDate = new Date();
      let years = [];
      let startYear = currentDate.getFullYear() - 2;
      for (let i = 0; i < 7; i++) {
         years.push({
            value: startYear.toString(),
            label: (startYear + 543).toString(),
         });
         startYear += 1;
      }
      setYears(years);
   };
   const getHrWallet = () => {
      setIsLoadingOptions(true);
      Axios.get(`/GSB/dashboard/rule/SearchHRWallet`)
         .then((response) => {
            setRespOptions(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoadingOptions(false);
         });
   };
   useEffect(() => {
      setOptionsData();
   }, [respOptions]);
   const setOptionsData = () => {
      if (respOptions) {
         setOptionHr(
            respOptions.map((category, dix) => ({
               value: category.walletId,
               label: `${category.walletCode} ${
                  category.walletNameTh
               } | คะแนนคงเหลือ: ${new Intl.NumberFormat().format(
                  category.walletCurrentBalance,
               )} / ${new Intl.NumberFormat().format(
                  category.walletAllocatePoint,
               )}`,
            })),
         );
      }
   };
   const selectCheckbox = watch('isUseParentWallet');
   useEffect(() => {
      register({ name: 'isUseParentWallet' });
   }, [register]);
   useEffect(() => {
      if (tableData == null) {
         setTableData([]);
      }
   }, [tableData]);
   const handlesUseParentWallet = (e) => {
      setValue('isUseParentWallet', e.target.checked);
   };
   const onSubmit = async (values) => {
      setIsLoading(true);
      let relatePersonsTemp = relatedPersons.map((el) =>
         Object.assign(el.data.employeeId),
      );
      const payload = {
         year: values.year.value,
         ruleNameTh: values.ruleNameTh ? values.ruleNameTh.trim() : '-',
         ruleNameEn: values.ruleNameEn ? values.ruleNameEn.trim() : '-',
         ruleConditionTh: values.ruleConditionTh
            ? values.ruleConditionTh.trim()
            : '-',
         ruleConditionEn: values.ruleConditionEn
            ? values.ruleConditionEn.trim()
            : '-',
         referenceDescription: values.referenceDescription
            ? values.referenceDescription.trim()
            : '-',
         ruleCode: values.ruleCode ? values.ruleCode.trim() : '-',
         ruleParentId: values.rule ? values.rule.data.ruleId : null,
         // isUseParentWallet: values.isUseParentWallet
         //   ? values.isUseParentWallet
         //   : false,
         rulePointAmount: values.rulePointAmount
            ? +reverseFormatNumber(values.rulePointAmount, 'en')
            : 0,
         gPoint: values.gPoint ? +reverseFormatNumber(values.gPoint, 'en') : 0,
         sPoint: values.sPoint ? +reverseFormatNumber(values.sPoint, 'en') : 0,
         bPoint: values.bPoint ? +reverseFormatNumber(values.bPoint, 'en') : 0,
         hrWalletId: values.hrWallet ? values.hrWallet.value : null,
         relatedEmployeeOrgId: relatePersonsTemp,
      };
      Axios.post('/GSB/dashboard/rule/CreateRule', payload)
         .then((resp) => {
            enqueueSnackbar('สร้างรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   const onSelected = (e) => {
      if (e == null) {
         e = [];
      }
      e.map((el, i) => (el.seq = i + 1));
      setTableData(e);
      setRelatedPersons(e);
   };
   const onDelete = (rowData) => {
      let deleted = tableData.filter((e) => e.seq !== rowData.seq);
      setTableData(deleted);
      setRelatedPersons(deleted);
   };
   const onSelectedRule = ([selected]) => {
      if (selected) {
         setRuleCode(selected.data.ruleCode);
         return selected;
      }
   };
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>เพิ่มหลักเกณฑ์</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={1}>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เลือกประเภทของหลักเกณฑ์
                           {errors.selectRuleType && (
                              <AlertLabel>กรุณาเลือก</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={optionsRules}
                                 placeholder={'เลือกประเภทของหลักเกณฑ์'}
                                 closeMenuOnSelect
                              />
                           }
                           rules={{ required: true }}
                           onChange={([selected]) => {
                              if (selected) {
                                 if (selected.value === 1) {
                                    setStateRuleMain({
                                       disable: !stateRuleMain.disable,
                                       isRequire: !stateRuleMain.isRequire,
                                    });
                                    setStateRuleSub({
                                       disable: true,
                                       isRequire: false,
                                    });
                                    setValue('rule', null);
                                 } else {
                                    setStateRuleMain({
                                       disable: true,
                                       isRequire: false,
                                    });
                                    setStateRuleSub({
                                       disable: !stateRuleSub.disable,
                                       isRequire: !stateRuleMain.isRequire,
                                    });
                                    setValue('hrWallet', null);
                                 }
                                 return selected;
                              } else {
                                 setValue('rule', null);
                                 setValue('hrWallet', null);
                                 setStateRuleMain({
                                    disable: true,
                                    isRequire: false,
                                 });
                                 setStateRuleSub({
                                    disable: true,
                                    isRequire: false,
                                 });
                              }
                              return selected;
                           }}
                           name='selectRuleType'
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        &nbsp;
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           เลือกกระเป๋าส่วนกลาง (HR)
                           {errors.hrWallet && (
                              <AlertLabel>
                                 กรุณาเลือกกระเป๋าส่วนกลาง (HR)
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={optionsHr}
                                 closeMenuOnSelect
                                 cacheOptions
                                 isLoading={isLoadingOptions}
                                 placeholder={'เลือกกระเป๋าส่วนกลาง (HR)'}
                                 isDisabled={stateRuleMain.disable}
                              />
                           }
                           // rules={{ required: stateRuleMain.isRequire }}
                           onChange={([selected]) => {
                              return selected;
                           }}
                           name={'hrWallet'}
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           หลักเกณฑ์หลัก
                           {/* {errors.rule && (
                    <AlertLabel>กรุณาเลือกหลักเกณฑ์หลัก</AlertLabel>
                  )}*/}
                        </TitleLabel>
                        <Controller
                           as={<SearchRule isDisabled={stateRuleSub.disable} />}
                           onChange={onSelectedRule}
                           name='rule'
                           // rules={{ required: stateRuleSub.isRequire }}
                           control={control}
                        />
                        {/*<FormControlLabel
                  control={
                    <Checkbox
                      name={'isUseParentWallet'}
                      color={'primary'}
                      size={'small'}
                      checked={selectCheckbox}
                      onChange={handlesUseParentWallet}
                    />
                  }
                  style={{ color: 'red' }}
                  label={'ภายใต้หลักเกณฑ์หลัก  (ไม่จำเป็นต้องระบุ)'}
                />*/}
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           รหัสหลักเกณฑ์
                           {errors.ruleCode && (
                              <AlertLabel>กรุณาระบุรหัสหลักเกณฑ์</AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleCode'}
                           value={ruleCode}
                           onChange={(e) => setRuleCode(e.target.value)}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ปี
                           {errors.year && (
                              <AlertLabel>กรุณาเลือกปี</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={years}
                                 placeholder={'เลือกปี'}
                                 closeMenuOnSelect
                                 menuShowInbody
                              />
                           }
                           onChange={([selected]) => {
                              return selected;
                           }}
                           name='year'
                           rules={{ required: true }}
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อหลักเกณฑ์ภาษาไทย
                           {errors.ruleNameTh && (
                              <AlertLabel>
                                 กรุณาระบุชื่อหลักเกณฑ์ภาษาไทย
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleNameTh'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อหลักเกณฑ์ภาษาอังกฤษ
                           {errors.ruleNameEn && (
                              <AlertLabel>
                                 กรุณาระบุชื่อหลักเกณฑ์ภาษาอังกฤษ
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleNameEn'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เงื่อนไขหลักเกณฑ์ภาษาไทย
                           {errors.ruleConditionTh && (
                              <AlertLabel>
                                 กรุณาระบุเงื่อนไขหลักเกณฑ์ภาษาไทย
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleConditionTh'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เงื่อนไขหลักเกณฑ์ภาษาอังกฤษ
                           {errors.ruleConditionEn && (
                              <AlertLabel>
                                 กรุณาระบุเงื่อนไขหลักเกณฑ์ภาษาอังกฤษ
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleConditionEn'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           รายละเอียดอ้างอิง
                           {errors.referenceDescription && (
                              <AlertLabel>
                                 กรุณาระบุรายละเอียดอ้างอิง
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'referenceDescription'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           คะแนนแยกตามหน่วย (GSB Way of Work)
                        </TitleLabel>
                        <Box display='flex' gridGap={'8px'}>
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'B'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             for SOCIETY
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'bPoint'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'G'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             with GOVERNANCE
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'gPoint'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'S'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             through DIGITALIZATION
                                          </InputAdornment>
                                       ),
                                    }}
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'sPoint'}
                              control={control}
                           />
                        </Box>
                     </Grid>

                     <Grid item xs={6}>
                        <TitleLabel>
                           คะแนนหลักเกณฑ์ทั้งหมด
                           {errors.rulePointAmount && (
                              <AlertLabel>
                                 กรุณาระบุคะแนนหลักเกณฑ์ทั้งหมด
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={<Input textAlign={'right'} />}
                           rules={{ required: true }}
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'rulePointAmount'}
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={8}>
                        <TitleLabel>
                           รายชื่อผู้เกี่ยวข้อง
                           <AlertLabel>(สามารถเพิ่มได้ไม่เกิน 2 คน)</AlertLabel>
                        </TitleLabel>
                        <SearchEmployee
                           value={relatedPersons}
                           isSearchable={
                              relatedPersons &&
                              relatedPersons.length != limitRelatedPerson
                           }
                           isMulti
                           onChange={onSelected}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <MaterialTable
                           columns={[
                              {
                                 field: 'seq',
                                 title: '#',
                              },
                              {
                                 field: 'data.employeeId',
                                 title: 'รหัสพนักงาน',
                              },
                              {
                                 field: 'data.displayName',
                                 title: 'ชื่อ-นามสกุล',
                              },
                              {
                                 field: 'data.department',
                                 title: 'สังกัด',
                              },
                           ]}
                           data={tableData}
                           options={{
                              showTitle: false,
                              headerStyle: headerStyle,
                              padding: 'dense',
                              search: false,
                              toolbar: false,
                              actionsColumnIndex: -1,
                              actionsCellStyle: {
                                 color: '#ccc',
                              },
                              pageSize: 5,
                              pageSizeOptions: [5, 10, 25, 50, 100],
                           }}
                           localization={{
                              header: { actions: 'ตัวจัดการ' },
                           }}
                           style={tableStyle}
                           icons={tableIcons}
                           actions={[
                              (rowData) => ({
                                 icon: React.forwardRef((props, ref) => (
                                    <FontAwesomeIcon
                                       ref={ref}
                                       {...props}
                                       color={'#ed1c24'}
                                       icon={faTrashAlt}
                                    />
                                 )),
                                 onClick: (e, rowData) => onDelete(rowData),
                                 tooltip: 'ลบ',
                              }),
                           ]}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        &nbsp;
                     </Grid>
                     {/*<Divider style={{ width: "100%" }} />
              <Typography
                className={classes.dividerFullWidth}
                color="textSecondary"
                display="block"
                variant="caption"
              >
                เพิ่มเติม
              </Typography>*/}
                     <Grid item xs={12}>
                        <Box>
                           <Button
                              variant='contained'
                              color='primary'
                              type={'submit'}
                           >
                              ยืนยัน
                           </Button>
                           <Button
                              variant='contained'
                              onClick={props.onClickClose}
                           >
                              ยกเลิก
                           </Button>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
            </Box>
         </form>
      </Paper>
   );
};

export default Create;
